import { API_ENDPOINT } from "../../../../constants/appConstant";
import { DropdownOptionType, SpeciallyAbledType } from "../../../../types";

type appiEndpointArgsProps = {
  fetchAPI: any;
  appName?: string;
  type?: string;
  name?: string;
  limit?: string;
  parentUuids?: string;
};

export const transformData = (
  entries: SpeciallyAbledType[],
): DropdownOptionType[] => {
  return entries.map((entry) => ({
    id: entry.uuid,
    text: entry.name,
  }));
};

export const getDropDownList = async (args: appiEndpointArgsProps) => {
  const { fetchAPI, type, parentUuids } = args;
  const speciallyAbledResponse = await fetchAPI(
    `${API_ENDPOINT().seekerProfile.masterDataMiddleware}?type=${type}${parentUuids ? "&parentUuids=" + parentUuids : ""}`,
    "GET",
  );
  const speciallyAbledData = (speciallyAbledResponse?.data as any)
    ?.data as SpeciallyAbledType[];
  const result = transformData(speciallyAbledData || []);
  return result;
};

export const getCMSBanner = async (
  fetchAPI: any,
  lob: string,
  category: string,
  siteContext: string,
) => {
  const speciallyAbledResponse = await fetchAPI(
    `${API_ENDPOINT().cms.banner}?lob=${lob}&page_category=${category}&filter_string=["${siteContext}"]&preview=False`,
    "GET",
  );
  return speciallyAbledResponse?.data;
};

export const removeNullAndEmptyValues = (
  obj: Record<string, any>,
): Record<string, any> => {
  const filterObject = (obj: Record<string, any>): Record<string, any> =>
    Object.fromEntries(
      Object.entries(obj)
        .filter(
          ([_, value]) => value !== null && value !== undefined && value !== "",
        )
        .map(([key, value]) => [
          key,
          value && typeof value === "object" && !Array.isArray(value)
            ? filterObject(value)
            : value,
        ]),
    );

  return filterObject(obj);
};
